export function clearAdditional() {
    return {
        type: 'ROUTES_CLEAR_ADDITIONAL'
    };
}
